"use strict";

exports.__esModule = true;
var _UserActionFields = require("./UserActionFields");
Object.keys(_UserActionFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserActionFields[key]) return;
  exports[key] = _UserActionFields[key];
});